
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useTeamMemberCount = (teamId: string) => {
  const [memberCount, setMemberCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const fetchMemberCount = async () => {
    try {
      setLoading(true);
      
      console.log('🔍 Fetching member count for team:', teamId);
      
      const { data, error } = await supabase
        .rpc('get_team_member_count', { team_uuid: teamId });

      if (error) {
        console.error('❌ Error fetching member count:', error);
        setMemberCount(1); // Default to 1 (team owner)
        return;
      }

      console.log('✅ Member count fetched:', data);
      setMemberCount(data || 1);
      
    } catch (err) {
      console.error('❌ Error in fetchMemberCount:', err);
      setMemberCount(1); // Default to 1 (team owner)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teamId) {
      fetchMemberCount();
    }
  }, [teamId]);

  return {
    memberCount,
    loading,
    fetchMemberCount
  };
};
